import { useUserStore } from '~/modules/user/stores/userStore';

export const useUser = () => {
  const { $api } = useNuxtApp() as NuxtAppType;
  const userStore = useUserStore();

  const setupUserData = async () => {
    try {
      const id = userStore.userID;
      if (!id) return;

      const response = await $api.users.getUserData({ id });
      if (response.success) {
        userStore.setUserData(response.data);
      }
    } catch (e) {
      console.warn('Ошибка при получении данных пользователя: ' + e);
      console.error(e);
      throw e;
    }
  };

  return {
    setupUserData,
  };
};
